import React, { useState, useEffect, useRef, useMemo } from "react";
import { UTILS, INS, CCTHUTILS } from "../config/API";
import { useNavigate } from 'react-router-dom';
import RadioField from "../components/RadioField";
import CheckboxField from "../components/CheckboxField";
import SignatureCanvas from "react-signature-canvas";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchProfileData } from '../utils/profile';
import appConfig, { getPortalKey } from "../config";

const WebForm = ({ parseData, onItemSelect }) => {
  const navigate = useNavigate();
  const [formFields, setFormFields] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps, setTotalSteps] = useState(1);
  const [groupedFields, setGroupedFields] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isAPILoading, setIsAPILoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [zipCodes, setZipCodes] = useState([]);
  const [showZipDropdown, setShowZipDropdown] = useState(false);
  const [options, setOptions] = useState([]);
  const [picklistCache, setPicklistCache] = useState({});
  const [signature, setSignature] = useState(null);
  const [files, setFiles] = useState([{ id: 1, file: null, type: "" }]);
  const [namechangeFiles, setNamechangeFiles] = useState([{ id: 1, file: null, type: "" }]);
  const [showSignature, setShowSignature] = useState(false);
  const [signatureText, setSignatureText] = useState("");
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [fileUploadText, setFileUploadText] = useState("");
  const [isSigned, setIsSigned] = useState(false);
  const [date, setDate] = useState("");
  const [error, setError] = useState(null);
  const sigPad = useRef(null);
  const [fileTypes, setFileTypes] = useState("");
  const namechangeFileTypes = ["Divorce Decree", "Adoption Decree", "Birth Certificate", "State Identification Card", "State Driver's License", "Passport"];
  const [profileData, setProfileData] = useState(null);
  const [certificationChecked, setCertificationChecked] = useState(false);
  const currentPath = window.location.pathname.toLowerCase();
  const shouldLoadProfile = currentPath.includes('apply') || currentPath.includes('page') || currentPath.includes('profile');
  const [taxPayerName, setTaxPayerName] = useState("");

  const isEnroll = parseData?.activeComponent === "Enrollment Application";

  // Get appName similar to Home.js
  const appName = useMemo(() => {
    const key = getPortalKey();
    return appConfig[key]?.name || appConfig.portal?.name || "";
  }, []);

  const handleHomeClick = () => {
    navigate("/home");
    if (onItemSelect) onItemSelect();
  };

  useEffect(() => {
    console.log("vivekdogra")
    console.log(appName);
    const selectedTaxPayer = localStorage.getItem("selectedBusinessName");
    if (selectedTaxPayer) {
      setTaxPayerName(selectedTaxPayer);
    }
  }, []);


  useEffect(() => {
    const fetchFormFields = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(UTILS, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Accept": "application/json"
          },
          body: new URLSearchParams({
            action: "desc",
            itype: parseData.iType,
            stype: parseData.sType,
          }),
        });

        const text = await response.text();
        const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
        console.log(cleanedText)

        let data;
        try {
          data = JSON.parse(cleanedText);
        } catch (parseError) {
          console.error("Failed to parse form fields:", parseError);
          throw new Error("Invalid server response format");
        }


        if (response.ok) {
          const filteredFields = data.Fields
            .filter(
              (field) =>
                ![
                  "itemid",
                  "autonumber",
                  "readonlydate",
                  "readonlypicklist",
                  "readonly",
                  "hidden",
                  "readonlylookup",
                  "linkedfield",
                  "inlinequery",
                  "person",
                ].includes(field.fieldtype)
            )
            .sort((a, b) => a.sortorder - b.sortorder);

          // Group fields by their type/category
          const groups = {
            applying: [],
            whoIsApplying: [], // New group for "Who is Applying" section
            personal: [],
            address: [],
            contact: [],
            additional: []
          };

          let currentGroup = 'applying';
          let foundApplyingSection = false;
          let foundWhoIsApplyingSection = false;

          filteredFields.forEach(field => {
            const fieldName = field.fieldname.toLowerCase();
            const displayName = field.displayname.toLowerCase();

            // Check for section labels
            if (field.fieldtype === 'label') {
              if (displayName.includes('who is applying')) {
                currentGroup = 'whoIsApplying';
                foundWhoIsApplyingSection = true;
              } else if (displayName.includes('applicant information')) {
                currentGroup = 'applying';
                foundApplyingSection = true;
              } else if (displayName.includes('address') || displayName.includes('location')) {
                currentGroup = 'address';
              } else if (displayName.includes('contact') || displayName.includes('phone') || displayName.includes('email')) {
                currentGroup = 'contact';
              } else if (displayName.includes('additional') || displayName.includes('other')) {
                currentGroup = 'additional';
              } else {
                currentGroup = 'personal';
              }
            }

            // Add the field to the current group
            groups[currentGroup].push(field);
          });

          // If no "Who is Applying" section was found, move all fields to personal
          if (!foundWhoIsApplyingSection) {
            groups.personal = [...groups.whoIsApplying, ...groups.personal];
            delete groups.whoIsApplying;
          }

          // If no "Applicant Information" section was found, move all fields to personal
          if (!foundApplyingSection) {
            groups.personal = [...groups.applying, ...groups.personal];
            delete groups.applying;
          }

          // Remove empty groups
          Object.keys(groups).forEach(key => {
            if (groups[key].length === 0) {
              delete groups[key];
            }
          });

          // Add signature and document sections if they exist
          if (data.Signature) {
            groups.signature = [{
              fieldtype: 'label',
              displayname: 'Signature',
              fieldname: 'signature_section'
            }];
          }

          if (data.FileUpload) {
            groups.documents = [{
              fieldtype: 'label',
              displayname: 'Document Upload',
              fieldname: 'documents_section'
            }];
          }

          setGroupedFields(groups);
          setTotalSteps(Object.keys(groups).length);
          setFormFields(filteredFields);

          const initialFormData = {};
          filteredFields.forEach((field) => {
            if (field.defaultvalue) {
              initialFormData[field.fieldname] = field.defaultvalue;
            }
          });

          setFormData(initialFormData);

          if (data.Signature) {
            setShowSignature(data.Signature);
            setSignatureText(data.SignatureText || "");
          }
          if (data.FileUpload) {
            setShowFileUpload(data.FileUpload);
            setFileUploadText(data.FileUploadText || "");
          }
          if (data.FileTypes) {
            setFileTypes(data.FileTypes);
          }

          const picklistFields = filteredFields.filter(
            (field) => field.fieldtype === "picklist"
          );
          await Promise.all(
            picklistFields.map(async (field) => {
              await fetchDropDownFields(field.itemvaluegroup);
            })
          );
        } else {
          throw new Error(data.message || "Failed to fetch form fields");
        }
      } catch (error) {
        console.error("Error loading form:", error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFormFields();
  }, [parseData.iType, parseData.sType]);

  useEffect(() => {
    const loadProfile = async () => {
      if (shouldLoadProfile) {
        try {
          const data = await fetchProfileData();
          if (parseData.sType !== "addresshist") {
            setProfileData(data);
          } else {
            const transformedData = Object.entries(data).reduce((acc, [key, value]) => {
              // Replace both address and zip keys
              let newKey = key;
              if (key === "Residential Zip") newKey = "Zip";
              if (key === "Residential Address") newKey = "Address";
              if (key === "Residential City") newKey = "City";
              if (key === "Residential State") newKey = "State";
              acc[newKey] = value;
              return acc;
            }, {});

            setProfileData(transformedData);
          }
        } catch (error) {
          console.error("Error loading profile data:", error);
        }
      }
    };
    loadProfile();
  }, []);

  useEffect(() => {
    if (!formFields.length || !profileData) return;

    setFormData(prev => {
      const updatedData = { ...prev };
      formFields.forEach(field => {
        const profileKey = Object.keys(profileData).find(
          key => key === field.displayname
        );
        if (profileKey && profileData[profileKey]) {
          updatedData[field.fieldname] = profileData[profileKey];
        }
      });
      return updatedData;
    });
  }, [formFields, profileData]);

  const fetchDropDownFields = async (itemValueGroup) => {
    if (picklistCache[itemValueGroup]?.data) return;

    setPicklistCache((prev) => ({
      ...prev,
      [itemValueGroup]: { ...prev[itemValueGroup], isLoading: true },
    }));

    try {
      const response = await fetch(UTILS, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "application/json" // Explicitly request JSON
        },
        body: new URLSearchParams({ action: "idv", s: itemValueGroup || "YesNo" }),
      });

      const text = await response.text();
      const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");

      let data;
      try {
        data = JSON.parse(cleanedText);
      } catch (parseError) {
        console.error("Failed to parse dropdown data:", parseError);
        console.error("Original text:", text);
        throw new Error("Invalid dropdown data format");
      }

      setPicklistCache((prev) => ({
        ...prev,
        [itemValueGroup]: { data, isLoading: false },
      }));
    } catch (error) {
      console.error("Error fetching dropdown:", error);
      setPicklistCache((prev) => ({
        ...prev,
        [itemValueGroup]: { isLoading: false, error: error.message },
      }));
    }
  };

  const handleCheckboxGroupChange = (e, fieldName) => {
    const { value, checked } = e.target;

    setFormData(prev => {
      // Get current value and split into array (handle empty/null cases)
      const currentValues = prev[fieldName] ? prev[fieldName].split(',') : [];

      let updatedValues;
      if (checked) {
        // Add the new value if checked
        updatedValues = [...currentValues, value];
      } else {
        // Remove the value if unchecked
        updatedValues = currentValues.filter(item => item !== value);
      }

      // Join the array back into a comma-separated string
      return {
        ...prev,
        [fieldName]: updatedValues.join(',')
      };
    });
  };

  const formatSSNOnChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    let formattedValue = "";

    if (input.length > 0) {
      formattedValue += input.substring(0, 3);
    }
    if (input.length > 3) {
      formattedValue += "-" + input.substring(3, 5);
    }
    if (input.length > 5) {
      formattedValue += "-" + input.substring(5, 9);
    }

    setFormData({ ...formData, [e.target.name]: formattedValue });
  };

  const formatPhoneOnChange = (e) => {
    const input = e.target;
    let phoneNumber = input.value.replace(/\D/g, '');
    if (phoneNumber.length > 10) {
      phoneNumber = phoneNumber.slice(0, 10);
    }

    let formattedPhone = phoneNumber;
    if (phoneNumber.length > 6) {
      formattedPhone = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    } else if (phoneNumber.length > 3) {
      formattedPhone = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    } else if (phoneNumber.length > 0) {
      formattedPhone = `(${phoneNumber}`;
    }

    input.value = formattedPhone;
    setFormData((prevFormData) => ({ ...prevFormData, [input.name]: formattedPhone }));
  };

  const fetchZipData = async (zip) => {
    try {
      const response = await fetch(UTILS, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "application/json" // Explicitly request JSON
        },
        body: new URLSearchParams({ action: "zip", s: zip }),
      });

      const text = await response.text();
      const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");

      let data;
      try {
        data = JSON.parse(cleanedText);
      } catch (parseError) {
        console.error("Failed to parse ZIP data:", parseError);
        throw new Error("Invalid ZIP data format");
      }

      if (response.ok) {
        setZipCodes(data);
      } else {
        throw new Error(data.message || "Failed to fetch ZIP codes");
      }
    } catch (error) {
      console.error("ZIP lookup failed:", error);
      setZipCodes([]);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'frc') {
      setInputValue(value);

      if (value.length >= 3) {
        fetchZipData(value);
        setShowZipDropdown(true);
      } else {
        setShowZipDropdown(false);
        setFormData((prevFormData) => ({ ...prevFormData, frc: "" }));
      }
    } else if (type === 'checkbox') {
      setFormData((prevFormData) => {
        const currentValues = prevFormData[name] || [];
        let updatedValues;

        if (checked) {
          updatedValues = [...currentValues, value];
        } else {
          updatedValues = currentValues.filter((item) => item !== value);
        }

        return {
          ...prevFormData,
          [name]: updatedValues,
        };
      });
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const handleZipSelection = (zip) => {
    setInputValue(zip.zipcode);
    setFormData((prevFormData) => ({ ...prevFormData, frc: zip.itemid }));
    setShowZipDropdown(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsAPILoading(true);
    setError(null);

    const formDataToSend = new FormData();
    const isNamechangeForTlingit = parseData.sType === "namechange" && appName === "My Tlingit & Haida Portal";
    formDataToSend.append('action', isEnroll ? 'enroll' : (isNamechangeForTlingit ? 'nameins' : 'ins'));

    if (parseData.activeComponent !== "Enrollment Application") {
      formDataToSend.append('itype', parseData.iType);
      formDataToSend.append('stype', parseData.sType);
    }

    if (showSignature && sigPad.current && !sigPad.current.isEmpty()) {
      try {
        const signatureDataUrl = sigPad.current.getTrimmedCanvas().toDataURL('image/png');
        const blob = await fetch(signatureDataUrl).then(res => res.blob());

        const signatureFile = new File([blob], 'signature.png', { type: 'image/png' });

        formDataToSend.append('file1', signatureFile);
        formDataToSend.append('artifacttype1', 'Signature');
        formDataToSend.append('signatureDate', date);
      } catch (error) {
        console.error("Error processing signature:", error);
      }
    }

    if (showFileUpload) {
      files.forEach((fileObj, index) => {
        if (fileObj.file) {
          const fileNumber = index + (showSignature && isSigned ? 2 : 1);
          console.log(`file${fileNumber}`)
          console.log(fileObj.type.replace(/\s+/g, '') || "")
          console.log(fileObj.type)
          formDataToSend.append(`file${fileNumber}`, fileObj.file);
          formDataToSend.append(`artifacttype`, fileObj.type.replace(/\s+/g, '') || "");
        }
      });
    }

    // Handle namechange file uploads
    if (parseData.sType === "namechange") {
      let fileNumberOffset = (showSignature && isSigned ? 1 : 0) + (showFileUpload ? files.filter(f => f.file).length : 0);
      namechangeFiles.forEach((fileObj, index) => {
        if (fileObj.file && fileObj.type) {
          const fileNumber = fileNumberOffset + index + 1;
          formDataToSend.append(`file${fileNumber}`, fileObj.file);
          formDataToSend.append(`artifacttype${fileNumber}`, fileObj.type.replace(/\s+/g, '') || "");
        }
      });
    }

    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        formDataToSend.append(key, formData[key]);
      }
    }

    if (appName === "TERO" && parseData.sType === "checkin") {
      formDataToSend.append("flexfield15", "Portal");
    }

    const fetchUrl = parseData.activeComponent === "Enrollment Application" ? UTILS : (isNamechangeForTlingit ? CCTHUTILS : INS);

    try {
      const response = await fetch(fetchUrl, { method: "POST", body: formDataToSend });
      const text = await response.text();

      const cleanedText = text.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
      console.log("Server response:", formData);
      console.log(cleanedText)

      let data;
      try {
        data = JSON.parse(cleanedText);
      } catch (parseError) {
        console.error("Failed to parse response:", parseError);
        console.error("Original text:", text);
        throw new Error("Invalid server response format");
      }

      if (data.result === "true") {
        alert("Thank you, your information has been received.");

        const resetFormData = {};
        formFields.forEach((field) => {
          if (field.fieldtype === "lookup") {
            setInputValue("");
            resetFormData[field.fieldname] = "";
          } else if (field.defaultvalue) {
            resetFormData[field.fieldname] = field.defaultvalue;
          } else {
            resetFormData[field.fieldname] = "";
          }
        });

        setFormData(resetFormData);

        if (sigPad.current) sigPad.current.clear();
        setFiles([{ id: 1, file: null, type: "" }]);
        setDate("");
        setIsSigned(false);
      } else if (data.status) {

      } else {
        throw new Error(data.message || "Submission failed");
      }

      if (parseData.activeComponent === "Enrollment Application") {
        alert(data.message || "Enrollment submitted");
        handleHomeClick()
      }
    } catch (error) {
      console.error("Submission error:", error);
      setError(error.message);
    } finally {
      setIsAPILoading(false);
    }
  };

  const handleDropdownClick = (itemValueGroup) => {
    if (picklistCache[itemValueGroup]) {
      setOptions(picklistCache[itemValueGroup]);
    } else {
      fetchDropDownFields(itemValueGroup);
    }
  };

  const handleAddMore = () => {
    setFiles([...files, { id: files.length + 1, file: null, type: "" }]);
  };

  const handleFileChange = (index, event) => {
    const updatedFiles = [...files];
    updatedFiles[index].file = event.target.files[0];
    setFiles(updatedFiles);
  };

  const handleFileTypeChange = (index, value) => {
    const updatedFiles = [...files];
    updatedFiles[index].type = value;
    setFiles(updatedFiles);
  };

  const handleNamechangeFileChange = (index, event) => {
    const updatedFiles = [...namechangeFiles];
    updatedFiles[index].file = event.target.files[0];
    setNamechangeFiles(updatedFiles);
  };

  const handleNamechangeFileTypeChange = (index, value) => {
    const updatedFiles = [...namechangeFiles];
    updatedFiles[index].type = value;
    setNamechangeFiles(updatedFiles);
  };

  const handleAddMoreNamechangeFile = () => {
    setNamechangeFiles([...namechangeFiles, { id: namechangeFiles.length + 1, file: null, type: "" }]);
  };

  const handleClear = () => {
    if (sigPad.current) {
      sigPad.current.clear();
      setIsSigned(false);
    }
  };

  const handleEnd = () => {
    if (sigPad.current) {
      setIsSigned(!sigPad.current.isEmpty());
    }
  };

  const getStepTitle = (step) => {
    const groupNames = Object.keys(groupedFields);
    const currentGroup = groupNames[step - 1];

    switch (currentGroup) {
      case 'applying':
        return "General Information";
      case 'whoIsApplying':
        return "Who is Applying";
      case 'personal':
        return "Personal Information";
      case 'address':
        return "Address Information";
      case 'contact':
        return "Contact Information";
      case 'additional':
        return "Additional Information";
      case 'signature':
        return "Signature";
      case 'documents':
        return "Document Upload";
      default:
        return "Step " + step;
    }
  };

  const getFieldsForCurrentStep = () => {
    const groupNames = Object.keys(groupedFields);
    const currentGroup = groupNames[currentStep - 1];
    return groupedFields[currentGroup] || [];
  };

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-64 space-y-4">
        <div className="relative">
          <div className="w-16 h-16 rounded-full absolute border-4 border-gray-200"></div>
          <div className="w-16 h-16 rounded-full animate-spin border-4 border-primary border-t-transparent border-r-transparent"></div>

          <div className="absolute inset-0 flex items-center justify-center">
            <svg
              className="w-6 h-6 text-primary"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 14l-7 7m0 0l-7-7m7 7V3"
              ></path>
            </svg>
          </div>
        </div>

        <div className="flex flex-col items-center space-y-2">
          <p className="text-gray-600 font-medium text-lg animate-pulse">Preparing Your Form...</p>
          <div className="flex space-x-2">
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className="w-2 h-2 bg-primary rounded-full animate-bounce"
                style={{ animationDelay: `${i * 0.1}s` }}
              ></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white p-8 rounded-lg shadow-lg text-center">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Form</h2>
        <p className="text-gray-700 mb-4">{error}</p>
        <button
          onClick={() => window.location.reload()}
          className="bg-[#711515] text-white px-6 py-2 rounded-lg hover:bg-[#5a1010] transition"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className={`${parseData?.activeComponent === "" ? "" : "w-[95%] md:w-[80%]"} ${parseData?.activeComponent === "" ? "" : "p-4 md:p-8"} mx-auto bg-white mt-5 rounded-lg ${parseData?.activeComponent === "" ? "" : "shadow-lg"}`}>
      {parseData?.activeComponent !== "" && (
        <h1 className="text-3xl font-bold text-gray-800 mb-4 text-center">
          {parseData.activeComponent}
        </h1>


      )}
      {error && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-6 rounded">
          <p>{error}</p>
        </div>
      )}

      {taxPayerName && (
        <p className="text-lg text-gray-600 -mt-2 text-center font-semibold">
          For: <span className="text-lg  text-[#711515]">{taxPayerName}</span>
        </p>
      )}

      <div className="mb-6">
        <div className="flex justify-between items-center mb-2">
          <span className="text-xs font-bold text-[#711515]">{Math.round((currentStep / totalSteps) * 100)}% Complete</span>
          <span className="text-xs text-gray-500">Step {currentStep} of {totalSteps}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div className="bg-[#711515] h-2 rounded-full" style={{ width: `${(currentStep / totalSteps) * 100}%` }}></div>
        </div>
      </div>

      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">{getStepTitle(currentStep)}</h2>

      <form onSubmit={handleSubmit} className="flex flex-col md:grid md:grid-cols-2 gap-6">
        {getFieldsForCurrentStep().map((field) => (
          <div className={`${field.fieldtype === "label" ? "col-span-2" : "col-span-1"}`} key={field.displayid}>
            <label className={`block ${field.fieldtype === "label" ? "font-bold text-base text-xl  w-full" : "text-gray-700 font-semibold"} mb-3`}>
              {field.required === "Y" && <span className="text-[#711515]">*</span>}
              {parseData.sType === "namechange" && field.displayname === "First Name"
                ? "Legal First Name"
                : parseData.sType === "namechange" && field.displayname === "Last Name"
                  ? "Legal Last Name"
                  : field.displayname
              }
              {field.tooltip && (
                <div className="inline-block relative ml-2 group">
                  <svg
                    className="w-5 h-5 text-gray-400 cursor-help"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 w-64 p-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-10">
                    {field.tooltip}
                    <div className="absolute left-1/2 transform -translate-x-1/2 top-full w-2 h-2 bg-gray-800 rotate-45"></div>
                  </div>
                </div>
              )}
            </label>
            {field.fieldtype === "lookup" ? (
              <div className="relative">
                <input
                  type="text"
                  name={field.fieldname}
                  value={inputValue}
                  onChange={handleChange}
                  className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                  style={{
                    width: '100%'
                  }}
                  required={field.required === "Y"}
                  maxLength={field.maxlength || ""}
                  autoComplete="off"
                  ref={inputRef}
                />

                {showZipDropdown && field.fieldname === 'frc' && (
                  <div
                    className="absolute z-10 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto"
                    style={{ width: inputRef.current ? inputRef.current.offsetWidth : '100%' }}
                  >
                    {zipCodes.length > 0 ? (
                      zipCodes.map((zip) => (
                        <div
                          key={zip.itemid}
                          className="p-3 hover:bg-gray-100 cursor-pointer"
                          onClick={() => handleZipSelection(zip)}
                        >
                          {zip.zipcode}
                        </div>
                      ))
                    ) : (
                      <div className="p-3 text-gray-500">No results found</div>
                    )}
                  </div>
                )}
              </div>
            ) : field.fieldtype === "text" || field.fieldtype === "numeric" || field.fieldtype === "currency" || field.fieldtype === "textdate" ? (
              <>
                <input
                  type="text"
                  name={field.fieldname}
                  value={formData[field.fieldname] || ""}
                  onChange={
                    field.onblur === "formatPhone(this);"
                      ? formatPhoneOnChange
                      : field.onfocus === "formatSSN(this);"
                        ? formatSSNOnChange
                        : handleChange
                  }
                  className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                  style={{
                    width: '100%'
                  }}
                  required={field.required === "Y"}
                  maxLength={field.maxlength || ""}
                />
                {field.displayname === "Email Address" && emailError && (
                  <p className="text-[#711515] text-sm mt-2">{emailError}</p>
                )}
              </>
            ) : field.fieldtype === "textarea" ? (
              <textarea
                name={field.fieldname}
                value={formData[field.fieldname] || ""}
                onChange={handleChange}
                className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                style={{
                  width: field.fieldlength ?
                    (parseInt(field.fieldlength, 10) > 100 ? '100%' : `${field.fieldlength}%`)
                    : '100%'
                }}
                required={field.required === "Y"}
                rows="4"
              ></textarea>
            ) : field.fieldtype === "picklist" ? (
              <div className="flex flex-col w-full">
                <div className="relative w-full">
                  <select
                    name={field.fieldname}
                    value={formData[field.fieldname] || ""}
                    onChange={handleChange}
                    className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent appearance-none"
                    required={field.required === "Y"}
                  >
                    <option value="">Select {field.displayname}</option>
                    {picklistCache[field.itemvaluegroup]?.isLoading ? (
                      <option disabled>Loading options...</option>
                    ) : (
                      (picklistCache[field.itemvaluegroup]?.data || []).map((option) => (
                        <option key={option.valueid} value={option.valuetext}>
                          {option.valuetext}
                        </option>
                      ))
                    )}
                  </select>
                  <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-700">
                    <svg
                      className="h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {picklistCache[field.itemvaluegroup]?.error && (
                  <p className="text-red-500 text-sm mt-1">
                    {picklistCache[field.itemvaluegroup].error}
                  </p>
                )}
              </div>
            ) : field.fieldtype === "datetimepl" ? (
              <div className="w-full">
                <DatePicker
                  selected={formData[field.fieldname] ? new Date(formData[field.fieldname]) : null}
                  onChange={(date) =>
                    setFormData({
                      ...formData,
                      [field.fieldname]: date.toISOString()
                    })
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="MMMM d, yyyy h:mm aa"
                  className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                  required={field.required === "Y"}
                  placeholderText="Select date and time"
                />
              </div>
            ) : field.fieldtype === "date" ? (
              <input
                type="date"
                name={field.fieldname}
                value={formData[field.fieldname] || ""}
                onChange={handleChange}
                className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                required={field.required === "Y"}
              />
            ) : field.fieldtype === "checkbox" ? (
              <CheckboxField
                field={field}
                formData={formData}
                handleCheckboxGroupChange={handleCheckboxGroupChange}
                picklistCache={picklistCache}
                setPicklistCache={setPicklistCache}
              />
            ) : field.fieldtype === "radio" ? (
              <RadioField
                field={field}
                formData={formData}
                handleChange={handleChange}
                picklistCache={picklistCache}
                setPicklistCache={setPicklistCache}
              />
            ) : null}
          </div>
        ))}

        {currentStep === Object.keys(groupedFields).indexOf('signature') + 1 && showSignature && (
          <div className="col-span-2">
            {signatureText && (
              <p className="text-gray-700 font-bold mt-4 text-base"
                dangerouslySetInnerHTML={{ __html: signatureText }} />
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Signature:</label>
                <div className="border border-gray-300 rounded-lg bg-gray-50 p-4 relative">
                  <SignatureCanvas
                    ref={sigPad}
                    penColor="#0000FF"
                    canvasProps={{ width: 450, height: 120, className: "sigCanvas" }}
                    onEnd={handleEnd}
                  />
                  <button
                    type="button"
                    onClick={handleClear}
                    className="absolute bottom-2 right-2 bg-red-500 text-white px-3 py-1 text-sm rounded-lg hover:bg-red-600 transition"
                  >
                    Clear Signature
                  </button>
                </div>
                {!isSigned && (
                  <p className="text-red-500 text-sm mt-1">Signature is required</p>
                )}
              </div>
              <div>
                <label className="block text-gray-700 font-semibold mb-2">Date:</label>
                <input
                  type="date"
                  name="signatureDate"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="w-full p-4 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                  required
                />
              </div>
            </div>
          </div>
        )}

        {currentStep === Object.keys(groupedFields).indexOf('documents') + 1 && showFileUpload && (
          <div className="col-span-2">
            {fileUploadText && (
              <p className="text-gray-700 font-bold mt-4 text-base"
                dangerouslySetInnerHTML={{ __html: fileUploadText }} />
            )}
            <div className="space-y-4">
              {files.map((file, index) => (
                <div key={file.id} className="flex flex-col space-y-2">
                  <div className="flex flex-col md:flex-row md:items-center gap-4">
                    <div className="w-full md:w-1/3">
                      <label className="text-gray-700 font-semibold mb-1 block">
                        Document Type {index + 1}:
                      </label>
                      <select
                        value={file.type || ""}
                        onChange={(e) => handleFileTypeChange(index, e.target.value)}
                        className="w-full p-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                        required
                      >
                        <option value="">Select Document Type</option>
                        {fileTypes && fileTypes.split(',').map((type, i) => (
                          <option key={i} value={type.trim()}>
                            {type.trim()}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full md:w-2/3">
                      <label className="text-gray-700 font-semibold mb-1 block">
                        Upload File {index + 1}:
                      </label>
                      <input
                        type="file"
                        onChange={(e) => handleFileChange(index, e)}
                        className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                        required
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
              type="button"
              onClick={handleAddMore}
              className="text-[#711515] hover:text-[#5a1010] underline mt-3 block font-semibold"
            >
              + Add More Documents
            </button>
          </div>
        )}

        {/* Namechange File Upload Section */}
        {parseData.sType === "namechange" && appName === "My Tlingit & Haida Portal" && (
          <div className="col-span-2">
            <label className="block text-gray-700 font-semibold mb-3">
              <span className="text-[#711515]">*</span> Supporting Document Upload (Required)
            </label>
            <div className="space-y-4">
              {namechangeFiles.map((file, index) => (
                <div key={file.id} className="flex flex-col space-y-2">
                  <div className="flex flex-col md:flex-row md:items-center gap-4">
                    <div className="w-full md:w-1/3">
                      <label className="text-gray-700 font-semibold mb-1 block">
                        File Type <span className="text-[#711515]">*</span>:
                      </label>
                      <select
                        value={file.type || ""}
                        onChange={(e) => handleNamechangeFileTypeChange(index, e.target.value)}
                        className="w-full p-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                        required
                      >
                        <option value="">Select File Type</option>
                        {namechangeFileTypes.map((type, i) => (
                          <option key={i} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="w-full md:w-2/3">
                      <label className="text-gray-700 font-semibold mb-1 block">
                        Upload File <span className="text-[#711515]">*</span>:
                      </label>
                      <input
                        type="file"
                        onChange={(e) => handleNamechangeFileChange(index, e)}
                        className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring-2 focus:ring-[#711515] focus:border-transparent"
                        required
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
              type="button"
              onClick={handleAddMoreNamechangeFile}
              className="text-[#711515] hover:text-[#5a1010] underline mt-3 block font-semibold"
            >
              + Add More Documents
            </button>
          </div>
        )}

        {/* Certification Text for Namechange */}
        {parseData.sType === "namechange" && currentStep === totalSteps && appName === "My Tlingit & Haida Portal" && (
          <div className="col-span-2 mt-4 mb-4">
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                id="certification"
                checked={certificationChecked}
                onChange={(e) => setCertificationChecked(e.target.checked)}
                className="mt-1 w-5 h-5 text-[#711515] border-gray-300 rounded focus:ring-[#711515] cursor-pointer"
                required
              />
              <label htmlFor="certification" className="text-gray-700 text-base font-medium italic cursor-pointer flex-1">
                I hereby certify that the information given above is correct and true and used for the purpose of updating my records with Central Council of the Tlingit and Haida Indian Tribes of Alaska.
              </label>
            </div>
          </div>
        )}

        <div className="col-span-2 flex justify-between mt-6">
          {currentStep > 1 && (
            <button
              type="button"
              onClick={handlePrevious}
              className="bg-gray-500 text-white px-6 py-3 rounded-lg hover:bg-gray-600 transition"
            >
              Previous
            </button>
          )}

          {currentStep < totalSteps ? (
            <button
              type="button"
              onClick={handleNext}
              className="bg-[#711515] text-white px-6 py-3 rounded-lg hover:bg-[#5a1010] transition ml-auto"
            >
              Next
            </button>
          ) : (
            <button
              type="submit"
              disabled={isAPILoading || (showSignature && !isSigned) || (parseData.sType === "namechange" && appName === "My Tlingit & Haida Portal" && (namechangeFiles.some(file => !file.file || !file.type) || !certificationChecked))}
              className={`bg-[#711515] text-white px-6 py-3 rounded-lg ${isAPILoading || (showSignature && !isSigned) || (parseData.sType === "namechange" && appName === "My Tlingit & Haida Portal" && (namechangeFiles.some(file => !file.file || !file.type) || !certificationChecked)) ? "opacity-50 cursor-not-allowed" : "hover:bg-[#5a1010]"} transition ml-auto`}
            >
              {isAPILoading ? "Submitting..." : "Submit"}
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default WebForm;